import * as types from "./actionTypes";

const initialState = {
  searchInput: "",
  searchType: "",
};

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.RESET_ACTION:
      return initialState;

    case types.SEARCH_COMPANIES_DATA:
      return {
        ...state,
        searchInput: action.payload.searchInput,
        searchType: action.payload.searchType,
        action: action.type,
      };
    default:
      return state;
  }
}
